<script setup lang="ts">
import AppImage from "../../components/AppImage.vue";
import SiteHeader from "../../components/SiteHeader.vue";
import FooterLower from "../../components/FooterLower.vue";
import FooterModal from "../../components/FooterModal.vue";
import { useCommon } from "../../composables/useCommon";
import { useNews } from "../../composables/useNews";

const common = useCommon();
const { articleDataArray } = useNews();

const openModal = (modalNum: number) => {
  common.isModalNum.value = modalNum;
  if (!common.isModalOpen.value) {
    common.modalToggle();
  }
};

const closeModal = () => {
  if (common.isModalOpen.value) {
    common.modalToggle();
  }
};
</script>

<template>
  <div
    class="be-wrapper"
    :class="{ 'is-menuopen': common.isMenuOpen.value }"
    v-cloak
  >
    <SiteHeader @toggle-menu="common.menuToggle" />

    <main id="be-content" class="be-content">
      <div class="be-breadcrumb">
        <div class="be-inner">
          <ul class="be-breadcrumb-list">
            <li class="be-breadcrumb-list__li"><a href="/">TOP</a></li>
            <li class="be-breadcrumb-list__li">お知らせ</li>
          </ul>
        </div>
      </div>

      <div class="be-pagetitle">
        <div class="be-inner">
          <h2 class="be-pagetitle__title js-scrollfade">
            <span class="font-en"><small>○ </small>News</span>
            <span class="be-pagetitle__title__sub">お知らせ</span>
          </h2>
        </div>
      </div>

      <div class="be-news">
        <div class="be-inner be-news__inner">
          <div class="be-news-list">
            <div
              class="be-news-list__li js-scrollfade"
              v-for="item in articleDataArray"
              :key="item.xmllink"
            >
              <a
                :href="item.xmllink"
                class="be-news-block"
                target="_blank"
                rel="noopener"
              >
                <div class="be-news-block__thumb js-scrollfade">
                  <AppImage
                    :src="item.xmlimage"
                    :alt="item.xmltitle"
                    width="800"
                    height="419"
                    class="be-resize"
                  />
                </div>
                <div class="be-news-block__content">
                  <div class="be-news-block__date font-en js-scrollfade">
                    {{ item.xmlpubdate }}
                  </div>
                  <div class="be-news-block__text js-scrollfade">
                    {{ item.xmltitle }}
                  </div>
                </div>
                <div class="be-news-block__arrow js-scrollfade"></div>
              </a>
            </div>
          </div>

          <div class="be-news__other js-scrollfade">
            <a
              href="https://note.bot-express.com/"
              target="_blank"
              rel="noopener"
              class="be-button--text be-bold"
              ><span>もっとみる</span><span class="be-icon--arrow2"></span
            ></a>
          </div>
        </div>
      </div>
    </main>

    <FooterLower @open-modal="openModal" />
    <FooterModal
      :is-open="common.isModalOpen.value"
      :modal-num="common.isModalNum.value"
      @close="closeModal"
    />
  </div>
</template>
